import {computed} from 'vue';
import axios from 'axios';
import { ElMessage } from 'element-plus';
import { transformI18n, i18n } from '@/langs/i18n';
import { getToken, removeToken } from './auth';
import { getFromLocalStorage } from './storage';

const language = computed(() => {
  const local = i18n.global.locale.value;
  if (local === 'zh' || local === 'zh-cn') {
    return 'zh-CN';
  }
  return 'en-US';
});

const service = axios.create({
  baseUrl: '',
  timeout: 30 * 1000, // request timeout
});

// request interceptor
service.interceptors.request.use(
  (config) => {
    config.baseURL = getFromLocalStorage('BaseUrlKey') || '';
    // Do something before request is sent
    const token = (config && config.token) || getToken();
    config.headers.Authorization = `Bearer ${token}`;
    config.headers['Accept-Language'] = language.value;
    return config;
  },
  (error) => {
    // Do something with request error
    console.log(error); // for debug
    Promise.reject(error);
  },
);

// response interceptor
service.interceptors.response.use(
  (response) => response,
  (error) => {
    let isShowNormalError = true;
    let option = {};
    const hideNormalError = () => {
      isShowNormalError = false;
    };
    const setMessageOption = (op) => {
      option = op;
    };
    setTimeout(() => {
      if (isShowNormalError) {
        let text = '';
        const isTimeOut = error.code === 'ECONNABORTED' && error.message.indexOf('timeout') !== -1;
        if (isTimeOut) {
          text = transformI18n('request.timeout');
        } else {
          const errorResponse = error.response;
          const status = errorResponse && errorResponse.status;
          switch (status) {
            case 403:
            case 400:
              text = (errorResponse.data && errorResponse.data.length > 0 && errorResponse.data[0].error) || '';
              break;
            case 404:
              text = transformI18n('request.networkError');
              break;
            case 500:
              text = transformI18n('request.serverError');
              break;
            case 401:
              removeToken();
              sessionStorage.clear();
              window.location.reload();
              text = transformI18n('request.loginExpires');
              break;
            default:
              break;
          }
        }
        if (text) {
          ElMessage({
            message: text,
            type: 'error',
            ...option,
          });
        }
      }
    });
    return Promise.reject({ ...error.response, hideNormalError, setMessageOption });
  },
);

export default service;
